/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} One_Code_At_A_Time_MessageInputs */

const en_one_code_at_a_time_message = /** @type {(inputs: One_Code_At_A_Time_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've already entered one invite code.`)
};

const ar_one_code_at_a_time_message = /** @type {(inputs: One_Code_At_A_Time_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لقد أدخلت رمز دعوة واحدًا بالفعل.`)
};

const de_one_code_at_a_time_message = /** @type {(inputs: One_Code_At_A_Time_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast bereits einen Einladungscode eingegeben.`)
};

const es_one_code_at_a_time_message = /** @type {(inputs: One_Code_At_A_Time_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya has introducido un código de invitación.`)
};

const fr_one_code_at_a_time_message = /** @type {(inputs: One_Code_At_A_Time_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez déjà saisi un code d’invitation.`)
};

const it_one_code_at_a_time_message = /** @type {(inputs: One_Code_At_A_Time_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai già inserito un codice invito.`)
};

const ja_one_code_at_a_time_message = /** @type {(inputs: One_Code_At_A_Time_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待コードはすでに1つ入力済みです。`)
};

const ko_one_code_at_a_time_message = /** @type {(inputs: One_Code_At_A_Time_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 초대 코드를 하나 입력했어요.`)
};

const pt_br_one_code_at_a_time_message = /** @type {(inputs: One_Code_At_A_Time_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você já inseriu um código de convite.`)
};

const ru_one_code_at_a_time_message = /** @type {(inputs: One_Code_At_A_Time_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уже ввели один код приглашения.`)
};

const th_one_code_at_a_time_message = /** @type {(inputs: One_Code_At_A_Time_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณกรอกรหัสเชิญไปแล้วหนึ่งรหัส`)
};

const tr_one_code_at_a_time_message = /** @type {(inputs: One_Code_At_A_Time_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaten bir davet kodu girdin.`)
};

const zh_cn_one_code_at_a_time_message = /** @type {(inputs: One_Code_At_A_Time_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已经输入过一组邀请码。`)
};

const zh_tw_one_code_at_a_time_message = /** @type {(inputs: One_Code_At_A_Time_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已經輸入過一組邀請碼。`)
};

/**
* | output |
* | --- |
* | "You've already entered one invite code." |
*
* @param {One_Code_At_A_Time_MessageInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const one_code_at_a_time_message = /** @type {((inputs?: One_Code_At_A_Time_MessageInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<One_Code_At_A_Time_MessageInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_one_code_at_a_time_message(inputs)
	if (locale === "ar") return ar_one_code_at_a_time_message(inputs)
	if (locale === "de") return de_one_code_at_a_time_message(inputs)
	if (locale === "es") return es_one_code_at_a_time_message(inputs)
	if (locale === "fr") return fr_one_code_at_a_time_message(inputs)
	if (locale === "it") return it_one_code_at_a_time_message(inputs)
	if (locale === "ja") return ja_one_code_at_a_time_message(inputs)
	if (locale === "ko") return ko_one_code_at_a_time_message(inputs)
	if (locale === "pt_br") return pt_br_one_code_at_a_time_message(inputs)
	if (locale === "ru") return ru_one_code_at_a_time_message(inputs)
	if (locale === "th") return th_one_code_at_a_time_message(inputs)
	if (locale === "tr") return tr_one_code_at_a_time_message(inputs)
	if (locale === "zh_cn") return zh_cn_one_code_at_a_time_message(inputs)
	return zh_tw_one_code_at_a_time_message(inputs)
});